import $ from "jquery";
import {
    getCurMainHost,
    getParam
} from "utilsES";

export const ajax = param => {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: param.method || "get",
            url: param.url || "",
            data: {
                params: JSON.stringify(param.data) || ""
            },
            dataType: param.type || "jsonp",
            jsonp: "callback",
            beforeSend: function(jqXHR, settings) {
                //在请求前给修改url（增加一个时间戳参数）
                settings.url += settings.url.match(/\?/) ? "&" : "?";
                settings.url += `cid=${getParam("cid") || 0}&scid=${getParam("scid")}`;
            },
            success: function(res) {
                if (parseInt(res.result) === 1) {
                    resolve(res);
                } else {
                    reject(res);
                }
            },
            error: function(errMsg) {
                reject(errMsg);
            }
        });
    });
};

const DEFAULT_API = {
    1: 'eventsapi.gm99.com', //gm99
    2: 'theventsapi.37games.com', //gmthai
    3: 'ujoyeventsapi.37games.com', //ujoy
    4: 'eventsapi.37games.com', //37games
    16: 'eventsapi.vgm.vn', //vgm
    20: 'kreventsapi.37games.com', //kr
    22: 'jpeventsapi.37games.com', //jp
    23: 'geventsapi.37games.com', //gevent
};

/**
 * 获取正确的接口api
 * @return {string} The result of the genUid.
 */
export const getRealEventsapi = function() {

    let curHostName = window.location.hostname;
    let realEventsapi = '';

    if (window.platformId && DEFAULT_API[window.platformId]) {
        if (curHostName === 'localhost') {
            realEventsapi = DEFAULT_API[window.platformId];
        } else {
            realEventsapi = DEFAULT_API[window.platformId].replace(/\.(.*)$/, '.' + getCurMainHost());
        }
    } else {
        console.log('配置项里面没有这个域');
        alert('請檢查html中是否全局設置window.platformId，沒有請補上，值在request_es.js看！')
    }

    return realEventsapi;
};